import React from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import Wrapper from './Wrapper';
import Button from './Button';
import Top from './Top';
import mainIllust from '../../img/ILLUST2.png'
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import './Main.css';

const MainWrapper = styled.div`
  text-align : center;
  margin : 0;
  padding : 0;
`;
const Spacer = styled.div`
  height : 4rem;
`;


const useStyles = makeStyles({
    title: {
        fontSize: 22,
        marginBottom: '10px',
        marginTop: '10px',
        textAlign: "center",
        fontFamily: 'spoqa-medium',
        fontWeight: 'bold',
        color: "#202e62"
    },
    text: {
        fontSize: 17,
        marginTop: '15px',
        textAlign: 'center',
        fontFamily: 'spoqa-regular',
        color: '#7b192f'
    },
    button: {
        textAlign: "center",
        marginTop: '30px'
    },
});

const Img = styled.img`
    width : 300px;
    overflow : hidden;
    margin-top : 11%;
    border-radius: 12px;
    @media (max-width : 349px) {
      width : 100%;
    }
`;

const MainCard = ({ history }) => {
    const classes = useStyles();
    return (
        <>
            <Wrapper>
                <MainWrapper>
                    <Top />
                    <Img src={mainIllust} />
                    <Typography className={classes.title}>"한국을 선물하세요"</Typography>
                    <Typography className={classes.text}>선물 고민은 이제 그만, <br /> 받는 사람 or 나에게<br /> <b>딱! 맞는 선물</b>을 찾아볼까요?</Typography>
                    <Button className={classes.button}
                        onClick={() => {
                            history.push("/question/1");
                        }}>지금 시작하기!</Button>
                </MainWrapper>
              
            </Wrapper>
            <Spacer />
        </>
    );
};

export default withRouter(MainCard);